import { AppState } from '../../..';
import { Dispatch, connect } from 'react-redux';
import { RelatedContractsComponentProperties, RelatedContractsComponent } from './related-contracts.component';
import { searchRelatedContractsByContract } from 'src/contract/contract.actions';

function mapStateToProps(
  state: AppState,
  ownProps: { contractId?: number }
): Partial<RelatedContractsComponentProperties> {
  return {
    contractId: ownProps.contractId,
    relatedContractsLoading: state.contract.relatedContractsLoading,
    relatedContractsPageCount: state.contract.relatedContractsPageCount,
    relatedContractsPageNumber: state.contract.relatedContractsPageNumber,
    relatedContractsPageSize: state.contract.relatedContractsPageSize,
    relatedContractsResults: state.contract.relatedContractsResults
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<RelatedContractsComponentProperties> {
  return {
    getRelatedContracts: (id, pageNumber, pageSize) =>
      dispatch(searchRelatedContractsByContract(id, pageNumber, pageSize))
  };
}

export const RelatedContracts = connect(
  mapStateToProps,
  mapDispatchToProps
)(RelatedContractsComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/related-contracts/related-contracts.container.ts